/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React layouts

import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import SettingsIcon from "@mui/icons-material/Settings";

import ForgotPassword from "layouts/authentication/forgot-password";
import ResetPassword from "layouts/authentication/reset-password";
import SignIn from "layouts/authentication/sign-in";
import Dashboard from "layouts/dashboard";
import Universities from "layouts/university";
import AddUniversity from "layouts/adduniversity";
import UniversityDetails from "layouts/universitydetails.js";
import UsersList from "layouts/users";
import ReportedUsers from "layouts/reportedusers";
import UserDetails from "layouts/userdetails.js";
import Cities from "layouts/city";
import AddCity from "layouts/addcity";
import CityDetails from "layouts/citydetails";
import Settings from "layouts/settings";
import citySidebarIcon from "assets/images/city/citySidebarIcon.svg";
import citySidebarActiveIcon from "assets/images/city/citySidebarActiveIcon.svg";

const routes = [
  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    route: "/",
    icon: "",
    component: <SignIn />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: "",
    component: <SignIn />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/authentication/forgot-password",
    icon: "",
    component: <ForgotPassword />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/authentication/reset-password",
    icon: "",
    component: <ResetPassword />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/reset-password/:token",
    icon: "",
    component: <ResetPassword />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <DashboardIcon size="20px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <GroupsIcon size="20px" />,
    component: <UsersList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Schools",
    key: "schools",
    route: "/schools",
    icon: <SchoolIcon size="20px" />,
    component: <Universities />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "City",
    key: "cities",
    route: "/cities",
    icon: (
      <img src={citySidebarIcon} alt="City" style={{ width: 20, height: 20, display: "block" }} />
    ),
    activeIcon: (
      <img
        src={citySidebarActiveIcon}
        alt="City"
        style={{ width: 20, height: 20, display: "block" }}
      />
    ),
    component: <Cities />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Add  University",
    key: "adduniversity",
    route: "/add-school",
    component: <AddUniversity />,
    noCollapse: true,
  },

  {
    type: "",
    name: "University Details",
    key: "universitydetails",
    route: "/school-details/:id",
    component: <UniversityDetails />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Edit University",
    key: "edituniversity",
    route: "/edit-school/:id",
    component: <AddUniversity />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Add City",
    key: "addcity",
    route: "/add-city",
    component: <AddCity />,
    noCollapse: true,
  },

  {
    type: "",
    name: "Edit City",
    key: "editcity",
    route: "/edit-city/:id",
    component: <AddCity />,
    noCollapse: true,
  },

  {
    type: "",
    name: "City Details",
    key: "citydetails",
    route: "/city-details/:id",
    component: <CityDetails />,
    noCollapse: true,
  },

    {
    type: "",
    name: "User Details",
    key: "userdetails",
    route: "/user-details/:id",
    component: <UserDetails />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Reported Users",
    key: "reported users",
    route: "/reported-users",
    icon: <PersonOffIcon size="20px" />,
    component: <ReportedUsers />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    route: "/settings",
    icon: <SettingsIcon size="20px" />,
    component: <Settings />,
    noCollapse: true,
  },
];

export default routes;
